import { HttpContext } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
  API_ENDPOINTS,
  ApiEndpoints,
  LoginReq,
  LoginRes,
  ModuleType,
  SetPasswordReq,
  SetPasswordRes,
  UserInfo,
} from '@contracts';
import { Observable } from 'rxjs';
import { ApiCilent } from '../../public-api';
import { SKIP_AUTH } from '../http/http-context.tokens';
import { SessionStore } from '../session/session.store';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private readonly apiClient: ApiCilent,
    private readonly sessionStore: SessionStore,
    @Inject(API_ENDPOINTS) private readonly endpoints: ApiEndpoints,
  ) {}

  login(payload: LoginReq): Observable<LoginRes> {
    const endpoint = this.endpoints.auth.login;
    return this.apiClient.post<LoginRes, LoginReq>({
      path: endpoint.path,
      domain: endpoint.domain,
      version: endpoint.version,
      body: payload,
      options: {
        context: new HttpContext().set(SKIP_AUTH, true),
      },
    });
  }

  setPassword(payload: SetPasswordReq): Observable<SetPasswordRes> {
    const endpoint = this.endpoints.auth.setPassword;
    return this.apiClient.post<SetPasswordRes, SetPasswordReq>({
      path: endpoint.path,
      domain: endpoint.domain,
      version: endpoint.version,
      body: payload,
      options: {
        context: new HttpContext().set(SKIP_AUTH, true),
      },
    });
  }

  saveSession(
    data: { token?: string; user: UserInfo },
    module: ModuleType,
  ): void {
    this.sessionStore.setAccessToken(data.token ?? null);
    this.sessionStore.setUserInfo(data.user);
    this.sessionStore.setModule(module);
  }

  clearSession(): void {
    this.sessionStore.clear();
  }

  isLoggedIn(): boolean {
    return this.sessionStore.isLoggedIn();
  }

  getUserInfo(): UserInfo | null {
    return this.sessionStore.getUserInfo();
  }

  getModule(): ModuleType | null {
    return this.sessionStore.getModule();
  }
}
